let body = $('body');

body.on('submit', '#import-csv-form', function (e) {
    e.preventDefault();

    let form = $(this);
    let loadingWrapper = $('#import-csv-form-loading');

    let formData = new FormData($(form).get(0));

    $.ajax({
        url: $(this).attr('action'),
        type: $(this).attr('method'),
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'JSON',
        beforeSend: function () {
            $(form).addClass('d-none');
            $(loadingWrapper).removeClass('d-none');
        },
        success: function (data) {
            window.formNotify('add', data.status, 'importCSV', 1500);
        },
        error: function (data) {
            window.formNotify('add', false, 'importCSV', 1500);
        },
        complete: function (data) {
            $(form).trigger('reset');
            $(form).removeClass('d-none');
            $(loadingWrapper).addClass('d-none');
        }
    });
});
